module.exports = __webpack_public_path__ + "static/media/Icon-CV_Set 1_Skills_List with bullets.8a16d4f7.svg";